// html setup
const uvDot = document.querySelector('.kbal-block--acf-top-section .svg-uv-dot svg');

//  Input setup
const mouseInput = {
	mouseX: {
		start: 0,
		end: window.innerWidth,
		current: 0,
	},
	mouseY: {
		start: 0,
		end: window.innerHeight,
		current: 0,
	},
};

mouseInput.mouseX.range = mouseInput.mouseX.end - mouseInput.mouseX.start;
mouseInput.mouseY.range = mouseInput.mouseY.end - mouseInput.mouseY.start;

// Output setup
const output = {
	x: {
		start: -30,
		end: 30,
		current: 0,
	},
	y: {
		start: -30,
		end: 30,
		current: 0,
	},
};

output.x.range = output.x.end - output.x.start;
output.y.range = output.y.end - output.y.start;

const mouse = {
	x: 0,
	y: 0,
};

const updateInputs = () => {
	// Mouse x input
	mouseInput.mouseX.current = mouse.x;
	mouseInput.mouseX.fraction = (mouseInput.mouseX.current - mouseInput.mouseX.start) / mouseInput.mouseX.range;

	// Mouse y input
	mouseInput.mouseY.current = mouse.y;
	mouseInput.mouseY.fraction = (mouseInput.mouseY.current - mouseInput.mouseY.start) / mouseInput.mouseY.range;
};

const updateOutputs = () => {
	// Output x and y
	output.x.current = output.x.end - mouseInput.mouseX.fraction * output.x.range;
	output.y.current = output.y.end - mouseInput.mouseY.fraction * output.y.range;
};

const updateElements = () => {
	// Add movement to images
	const imageDepth = 0.1;
	const imageOutput = {
		x: output.x.current - output.x.current * imageDepth,
		y: output.y.current - output.y.current * imageDepth,
	};

	if (uvDot) {
		uvDot.style.transform = `translateX(${imageOutput.x}px)`;
		uvDot.style.transform += `translateY(${imageOutput.y}px)`;
	}
};
const handleMouseMove = (e) => {
	mouse.x = e.clientX;
	mouse.y = e.clientY;

	updateInputs();
	updateOutputs();
	updateElements();
};

const handleResize = (e) => {
	mouseInput.mouseX.end = window.innerWidth;
	mouseInput.mouseX.range = mouseInput.mouseX.end - mouseInput.mouseX.start;

	mouseInput.mouseY.end = window.innerHeight;
	mouseInput.mouseY.range = mouseInput.mouseY.end - mouseInput.mouseY.start;
};

window.addEventListener('mousemove', handleMouseMove);
window.addEventListener('resize', handleResize);
